import styles from "./ErrorDemo.module.css";
import ActionButton from "../ActionButton";
import React, {useState} from "react";

const strings = {
    eventError: "Event Error",
    renderError: "Render Error",
};

export default function ErrorDemo() {
    const [isErrorMode, setIsErrorMode] = useState(false);

    if (isErrorMode) {
        throw new Error("Test render error.");
    }

    return (
        <>
            <ActionButton
                className={styles.button}
                label={strings.eventError}
                onClick={() => {
                    throw new Error("Test event error.");
                }}
            />
            <ActionButton
                className={styles.button}
                label={strings.renderError}
                onClick={() => setIsErrorMode(true)}
            />
        </>
    );
}
